/**
 * @generated SignedSource<<cf0d1f77f15a15cbf9dcc5b9b88de8bc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useDibsSetApprovalForAll_viewer$data = {
  readonly isNftAuctionV2Enabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"useMarketSettings_viewer">;
  readonly " $fragmentType": "useDibsSetApprovalForAll_viewer";
};
export type useDibsSetApprovalForAll_viewer$key = {
  readonly " $data"?: useDibsSetApprovalForAll_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDibsSetApprovalForAll_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useDibsSetApprovalForAll_viewer",
  "selections": [
    {
      "alias": "isNftAuctionV2Enabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "nftAuctionV2"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"nftAuctionV2\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMarketSettings_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "cc9d5ff2abb662ce0b543dd9d11c0b67";

export default node;
